import { render, staticRenderFns } from "./StandardModelQuarksViz.vue?vue&type=template&id=143b88de&scoped=true"
import script from "./StandardModelQuarksViz.vue?vue&type=script&lang=js"
export * from "./StandardModelQuarksViz.vue?vue&type=script&lang=js"
import style0 from "./StandardModelQuarksViz.vue?vue&type=style&index=0&id=143b88de&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "143b88de",
  null
  
)

export default component.exports